import axios from 'axios';

import { API } from './constants';

import {
  refreshTokenInterceptor,
  responseErrorInterceptor,
  responseSuccessInterceptor,
} from './interceptors';

const instance = axios.create({
  baseURL: API,
});

export const plugBoletosInstance = axios.create({
  baseURL: 'https://plugboleto.com.br/api/v1',
  headers: {
    'token-sh': 'f214bcc145ae418d77b0d541185be089',
  },
});

export const publicInstance = axios.create({ baseURL: API });

export const visionApi = axios.create({
  baseURL: process.env.REACT_APP_PYTHON_URL,
});

export const tefApi = axios.create({
  baseURL: process.env.REACT_APP_TEF_URL,
  transformResponse: [
    (data) => {
      if (data && JSON.parse(data).funcao === 'Error') return JSON.parse(data);

      if (data !== undefined && data && JSON.parse(data).resultado) {
        const newData = JSON.parse(data);
        data = {
          ...newData,
          resultado: JSON.parse(newData.resultado?.replace(/\r\n/g, '\\r\\n')),
        };
      }

      return data;
    },
  ],
});

instance.interceptors.request.use(refreshTokenInterceptor);

instance.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor,
);

export default instance;
